import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
import { PageNotFoundComponent } from './shared/404/page-not-found/page-not-found.component';
const routes: Routes = [
  // { path: '', redirectTo: '' ,pathMatch:'full'},
  // Register page lives at /signup (its default child in the auth module).
  { path: 'signup', loadChildren: () => import('./account/auth/auth.module').then(m => m.AuthModule) },
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  { path: 'home-page', loadChildren: () => import('./home-page/home-page.module').then(m=>m.HomePageModule)},
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)},
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
